// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header-module--logo--3yAKW","headerWrapper":"Header-module--headerWrapper--2YqWX","navigation":"Header-module--navigation--1II0G"};